export default {
    bindings: {
        loading: "=",
        noDelete: '<'
    },
    controller: 'basketItemsController',
    template: require('../views/basket.items.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/basket.items.component.js